import { reactSelectStylingConst, STYLES } from "../../../../constants";

const { blackColor, grayColor, transparentColor } = reactSelectStylingConst;

// Styling react select dropdown
export const customStyle = {
  option: (baseStyles, state) => ({
    ...baseStyles,
    backgroundColor: state.isSelected ? transparentColor : STYLES.AUTO,
    color: state.isDisabled ? grayColor : blackColor,
  }),
};
